import { useQuery } from '@tanstack/react-query';
import type { BusySlot, OutlookEvent, OutlookStatus } from '@avslack/shared';
import { apiFetch } from '../lib/api';
import { apiBase } from '../lib/runtime';
import { calendarKey } from './calendar';

/**
 * OUTLOOK-KAPCSOLAT (docs/23, B1) - a kliens oldal.
 *
 * Az allapot a Beallitasokhoz; a sajat Outlook-esemenyek a naptar kulcsa ALATT
 * (`calendar`), igy ugyanaz a `calendar.changed` jelzes frissiti oket, mint az
 * AVSlack-bejegyzeseket.
 */

export const outlookStatusKey = ['outlook', 'status'] as const;

export function useOutlookStatus() {
  return useQuery({
    queryKey: outlookStatusKey,
    queryFn: () => apiFetch<OutlookStatus>('/api/outlook/status'),
    staleTime: 60_000,
  });
}

/**
 * Az osszekotes inditasa - TELJES lapvaltassal: a szerver a Microsoft
 * jovahagyo lapjara iranyit at, ahol a felhasznalonak a sajat bongeszojeben
 * kell lennie (mint a ProjectFlow-nal).
 */
export function startOutlookLink(): void {
  window.location.href = `${apiBase()}/api/outlook/link`;
}

export const unlinkOutlook = () =>
  apiFetch<{ ok: boolean }>('/api/outlook/link', { method: 'DELETE' });

export const syncOutlookNow = () =>
  apiFetch<{ ok: boolean; changed: number }>('/api/outlook/sync', { method: 'POST' });

/** A SAJAT Outlook-esemenyek egy savban - csak ha be van kotve. */
export function useOutlookEvents(from: Date, to: Date, enabled: boolean) {
  return useQuery({
    queryKey: [...calendarKey, 'outlook', from.toISOString(), to.toISOString()],
    queryFn: () => {
      const params = new URLSearchParams({ from: from.toISOString(), to: to.toISOString() });
      return apiFetch<{ events: OutlookEvent[] }>(`/api/outlook/events?${params}`).then(
        (result) => result.events,
      );
    },
    enabled,
    staleTime: 60_000,
  });
}

/** Egy kollega foglalt savjai (cim nelkul) - csak ha a felulet kinyitja. */
export function useBusySlots(userId: string, from: Date, to: Date, enabled: boolean) {
  return useQuery({
    queryKey: [...calendarKey, 'busy', userId, from.toISOString(), to.toISOString()],
    queryFn: () => {
      const params = new URLSearchParams({ from: from.toISOString(), to: to.toISOString() });
      return apiFetch<{ slots: BusySlot[] }>(`/api/users/${userId}/busy?${params}`).then(
        (result) => result.slots,
      );
    },
    enabled,
    staleTime: 60_000,
  });
}
